import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { CheckCircle, XCircle, Clock, ArrowRight, Home, Calendar, ArrowLeft } from 'lucide-react'

const PaymentResult = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  
  const status = searchParams.get('status')
  const message = decodeURIComponent(searchParams.get('message') || '')
  const refId = searchParams.get('ref_id')
  
  const [countdown, setCountdown] = useState(10)
  const [isVisible, setIsVisible] = useState(false)
  const [iconScale, setIconScale] = useState(false)

  useEffect(() => {
    // انیمیشن ورود
    const timer = setTimeout(() => {
      setIsVisible(true)
      setIconScale(true)
    }, 100)

    // تایمر انتقال خودکار
    const countdownInterval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval)
            navigate('/')
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => {
      clearTimeout(timer)
      clearInterval(countdownInterval)
    }
  }, [navigate])

  const isSuccess = status === 'success'
  
  const handleGoToProfile = () => {
    navigate('/')

  }

  const handleGoToHome = () => {
    navigate('/')
  }

  const handleGoToReserve = () => {
    navigate('/reserve')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4" dir="rtl">
      <div className={`max-w-3xl w-full transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-200">
          
          {/* هدر */}
          <div className={`${isSuccess ? 'bg-gradient-to-r from-emerald-500 to-teal-500' : 'bg-gradient-to-r from-rose-500 to-pink-500'} p-6 text-center`}>
            <div className={`inline-block p-4 bg-white/20 rounded-full backdrop-blur-sm transition-transform duration-500 ${iconScale ? 'scale-100' : 'scale-0'}`}>
              {isSuccess ? (
                <CheckCircle className="w-16 h-16 text-white" strokeWidth={1.5} />
              ) : (
                <XCircle className="w-16 h-16 text-white" strokeWidth={1.5} />
              )}
            </div>
            
            <h1 className={`text-2xl font-bold text-white mt-4 transition-all duration-500 delay-100 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
              {isSuccess ? 'پرداخت موفقیت‌آمیز!' : 'پرداخت ناموفق'}
            </h1>
            
            <p className={`text-white/90 mt-2 transition-all duration-500 delay-150 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
              {isSuccess ? 'رزرو شما با موفقیت ثبت شد' : 'متاسفانه پرداخت تکمیل نشد'}
            </p>
          </div>

          {/* بدنه */}
          <div className="p-8">
            <div className={`space-y-6 transition-all duration-500 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}>
              {/* آیکون وضعیت */}
              <div className="flex justify-center">
                <div className={`p-6 rounded-full transition-all duration-500 ${isSuccess ? 'bg-emerald-50' : 'bg-rose-50'} ${isVisible ? 'scale-100' : 'scale-90'}`}>
                  {isSuccess ? (
                    <CheckCircle className="w-20 h-20 text-emerald-500 transition-all duration-700 delay-300" />
                  ) : (
                    <XCircle className="w-20 h-20 text-rose-500 transition-all duration-700 delay-300" />
                  )}
                </div>
              </div>

              {/* پیام */}
              <div className="text-center">
                <h2 className="text-xl font-semibold text-slate-800 mb-2">
                  {isSuccess ? 'تبریک!' : 'با عرض پوزش'}
                </h2>
                <p className="text-slate-600 leading-relaxed">
                  {isSuccess 
                    ? `پرداخت شما با موفقیت انجام شد. کد پیگیری: ${refId || 'نامشخص'}`
                    : message || 'در فرآیند پرداخت مشکلی پیش آمده است.'
                  }
                </p>
              </div>

              {/* جزئیات */}
              {isSuccess && refId && (
                <div className={`bg-slate-50 rounded-xl p-4 border border-slate-200 transition-all duration-500 delay-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
                  <div className="flex items-center justify-between">
                    <span className="text-slate-600 font-medium">کد پیگیری:</span>
                    <span className="font-mono text-lg font-bold text-emerald-600 bg-emerald-50 px-3 py-1 rounded-lg animate-pulse">
                      {refId}
                    </span>
                  </div>
                  <p className="text-sm text-slate-500 mt-3 text-center">
                    این کد را نزد خود نگه دارید. در صورت نیاز به پشتیبانی، این کد را ارائه دهید.
                  </p>
                </div>
              )}

              {/* تایمر */}
              <div className="flex items-center justify-center gap-2 text-slate-500">
                <Clock className="w-5 h-5 animate-pulse" />
                <span className="text-sm">
                  انتقال خودکار به صفحه رزرو هاتون در 
                  <span className="font-bold text-slate-700 mx-1 animate-pulse">{countdown}</span>
                  ثانیه دیگر
                </span>
              </div>

              {/* دکمه‌ها */}
              <div className="space-y-3 pt-4">
                <button
                  onClick={handleGoToHome}
                  className={`w-full py-3.5 rounded-xl font-semibold flex items-center justify-center gap-2 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] ${
                    isSuccess 
                      ? 'bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg hover:shadow-emerald-200'
                      : 'bg-rose-500 hover:bg-rose-600 text-white shadow-lg hover:shadow-rose-200'
                  }`}
                >
                  مشاهده رزروهای من
                  <ArrowLeft className="w-5 h-5" />
                </button>

                <div className="grid grid-cols-2 gap-3">
                  <button
                    onClick={handleGoToHome}
                    className="py-3 rounded-xl font-medium bg-slate-100 hover:bg-slate-200 text-slate-700 flex items-center justify-center gap-2 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] shadow hover:shadow-md"
                  >
                    <Home className="w-5 h-5" />
                    صفحه اصلی
                  </button>

                  <button
                    onClick={handleGoToReserve}
                    className="py-3 rounded-xl font-medium bg-purple-100 hover:bg-purple-200 text-purple-700 flex items-center justify-center gap-2 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] shadow hover:shadow-md"
                  >
                    <Calendar className="w-5 h-5" />
                    رزرو جدید
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* فوتر */}
          <div className="bg-slate-50 border-t border-slate-200 p-4 text-center">
            <p className="text-sm text-slate-500">
              {isSuccess 
                ? 'از اعتماد شما متشکریم. در صورت هرگونه سوال با پشتیبانی تماس بگیرید.'
                : 'می‌توانید مجدداً تلاش کنید یا از روش‌های دیگر پرداخت استفاده نمایید.'
              }
            </p>
            <p className="text-xs text-slate-400 mt-2">
              شماره پشتیبانی: ۰۹۰۰۶۱۶۷۰۷۰
            </p>
          </div>
        </div>

        {/* دکمه بستن */}
        <button
          onClick={() => navigate(-1)}
          className="mt-6 mx-auto cursor-pointer block text-slate-500 hover:text-slate-700 text-sm font-medium flex items-center justify-center gap-1 transition-colors duration-300"
        >
          <ArrowRight className="w-4 h-4" />
          بازگشت
        </button>
      </div>
    </div>
  )
}

export default PaymentResult
